export const FEED_ACTIONS = {
  NEWS_FEED_FETCHED: 'NEWS_FEED_FETCHED',
  FEED_FETCHED: 'FEED_FETCHED',
  UPDATE_FEED: 'UPDATE_FEED',
};
